import * as React from "react";

function SvgStore(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M2.957 0L0 2.957 4.435 7.39l-2.957 2.957h8.87v-8.87L7.39 4.435 2.957 0zM5.913 13.304H8.87v5.913H5.913v-5.913zM31.044 13.304H34v5.913h-2.956v-5.913zM8.87 16.26h22.174v2.957H8.87v-2.956zM5.913 20.696H8.87v5.913H5.913v-5.913zM31.044 20.696H34v5.913h-2.956v-5.913zM8.87 23.652h22.174v2.957H8.87v-2.957zM5.913 28.087H8.87V34H5.913v-5.913zM31.044 28.087H34V34h-2.956v-5.913zM8.87 31.044h22.174V34H8.87v-2.956z"
        fill="#FFF"
      />
    </svg>
  );
}

export default SvgStore;
